import { render, staticRenderFns } from "./Experiencias.vue?vue&type=template&id=20ee3426"
import script from "./Experiencias.vue?vue&type=script&lang=js"
export * from "./Experiencias.vue?vue&type=script&lang=js"
import style0 from "./Experiencias.vue?vue&type=style&index=0&id=20ee3426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports